import CircleLoader from "react-spinners/CircleLoader";
import styles from "./styles.module.css";

const Loading = ({ loading, color = "blue", overlay = false }) => {
  // do not render anything when not loading to avoid layout spacer
  if (!loading) return null;

  const colorSelected = color === "white" ? "#FFFFFF" : "#18316e";

  return (
    <div className={`${styles.container} ${overlay ? styles.overlay : ''}`}>
      <div className={styles.loading}>
        <CircleLoader
          color={colorSelected}
          loading={loading}
          size={100}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    </div>
  );
};

export default Loading;
